import SmsMarketing from "./SmsMarketing";

export default function GestaoTelefones() {
  return <SmsMarketing allowedTabs={["contatos", "blacklist"]} pageTitle="Gestão de Telefones" pageSubtitle="Cadastro, validação, segmentação e bloqueio de telefones para campanhas SMS, ligação e WhatsApp" />;
}
